
import { defineComponent } from 'vue'
import { iTenant, iTenantToSave } from '../TenantManagement'
import { AxiosResponse } from 'axios'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import tabViewDescriptor from './TenantManagementTabViewDescriptor.json'
import TenantDetail from './DetailTab/TenantDetail.vue'
import ProductTypes from './SelectionTableTab/SelectionTable.vue'
import useValidate from '@vuelidate/core'

export default defineComponent({
    components: {
        TabView,
        TabPanel,
        TenantDetail,
        ProductTypes
    },
    props: {
        selectedTenant: {
            type: Object,
            required: false
        },
        licenses: Array
    },
    emits: ['touched', 'closed', 'inserted'],
    data() {
        return {
            tabViewDescriptor,
            loading: false,
            touched: false,
            operation: 'insert',
            v$: useValidate() as any,
            tenant: {} as iTenant,
            listOfThemes: [] as any,
            availableLicenses: [] as any,
            listOfProductTypes: [] as any,
            listOfSelectedProducts: [] as any,
            listOfDataSources: [] as any,
            listOfSelectedDataSources: [] as any
        }
    },
    computed: {
        buttonDisabled(): any {
            if ((this.listOfSelectedProducts && this.listOfSelectedProducts.length === 0) || (this.listOfSelectedDataSources && this.listOfSelectedDataSources.length === 0) || this.v$.$invalid) {
                return true
            }
            return false
        }
    },
    watch: {
        selectedTenant() {
            this.tenant = { ...this.selectedTenant } as iTenant
            this.getTenantData()
        },
        licenses() {
            this.availableLicenses = this.licenses
        }
    },
    mounted() {
        if (this.selectedTenant) {
            this.tenant = { ...this.selectedTenant } as iTenant
        }
        this.availableLicenses = this.licenses
        this.loadAllData()
        this.getTenantData()
    },
    methods: {
        loadData(dataType: string) {
            return this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `multitenant${dataType}`)
        },

        async loadAllData() {
            this.loading = true
            await this.loadData('/themes').then((response: AxiosResponse<any>) => {
                this.listOfThemes = response.data.root
            })
            await this.loadData('/datasources').then((response: AxiosResponse<any>) => {
                this.listOfDataSources = response.data.root
            })
            await this.loadData('/producttypes').then((response: AxiosResponse<any>) => {
                this.listOfProductTypes = response.data.root
                this.filterArrayByTargetArr(this.listOfProductTypes, this.availableLicenses)
            })
            this.loading = false
        },

        filterArrayByTargetArr(sourceArr, targetArr) {
            const newArr = sourceArr.filter((elem) => targetArr.find((target) => elem.LABEL == target.product))
            this.listOfProductTypes = newArr
        },

        async getTenantData() {
            this.loading = true
            this.listOfSelectedProducts = null
            this.listOfSelectedDataSources = null
            this.touched = false

            await this.loadData(`/producttypes?TENANT=${this.tenant.TENANT_NAME}`).then((response: AxiosResponse<any>) => {
                var productTypes = response.data.root

                this.listOfSelectedProducts = []
                this.copySelectedElement(productTypes, this.listOfSelectedProducts)
            })
            await this.loadData(`/datasources?TENANT=${this.tenant.TENANT_NAME}`).then((response: AxiosResponse<any>) => {
                var dataSources = response.data.root

                this.listOfSelectedDataSources = []
                this.copySelectedElement(dataSources, this.listOfSelectedDataSources)
            })
            this.loading = false
        },
        copySelectedElement(source, selected) {
            for (let i = 0; i < source.length; i++) {
                if (source[i].CHECKED == true) {
                    selected.push(source[i])
                }
            }
        },

        async handleSubmit() {
            if (this.v$.$invalid) {
                return
            }
            let url = process.env.VUE_APP_RESTFUL_SERVICES_PATH + 'multitenant/save'

            await this.$http.post(url, this.createTenantToSave()).then((response: AxiosResponse<any>) => {
                if (this.selectedTenant) {
                    this.$store.commit('setInfo', {
                        title: this.$t(this.tabViewDescriptor.operation[this.operation].toastTitle),
                        msg: this.$t(this.tabViewDescriptor.operation.success)
                    })
                } else {
                    this.$store.commit('setInfo', {
                        title: this.$t(this.tabViewDescriptor.operation[this.operation].toastTitle),
                        msg: this.$t(this.tabViewDescriptor.operation.success) + response.data.NEW_USER,
                        duration: 0
                    })
                }

                this.$emit('inserted')
                this.$router.replace('/tenants-management')
            })
        },

        createTenantToSave() {
            const tenantToSave = {} as iTenantToSave
            tenantToSave.TENANT_ID = this.tenant.TENANT_ID ? '' + this.tenant.TENANT_ID : ''
            tenantToSave.TENANT_NAME = this.tenant.TENANT_NAME
            this.tenant.TENANT_THEME ? (tenantToSave.TENANT_THEME = this.tenant.TENANT_THEME) : ''
            tenantToSave.TENANT_IMAGE = this.tenant.TENANT_IMAGE
            tenantToSave.TENANT_IMAGE_WIDE = this.tenant.TENANT_IMAGE_WIDE
            tenantToSave.DS_LIST = this.listOfSelectedDataSources.map((dataSource) => {
                delete dataSource.CHECKED
                return dataSource
            })
            tenantToSave.PRODUCT_TYPE_LIST = this.listOfSelectedProducts.map((productType) => {
                delete productType.CHECKED
                return productType
            })
            return tenantToSave
        },

        closeTemplate() {
            this.$router.push('/tenants-management')
            this.$emit('closed')
        },

        onFieldChange(event) {
            this.tenant[event.fieldName] = event.value
            this.touched = true
            this.$emit('touched')
        },

        setSelectedProducts(categories: any[]) {
            this.listOfSelectedProducts = categories
            this.touched = true
            this.$emit('touched')
        },

        setSelectedDataSources(categories: any[]) {
            this.listOfSelectedDataSources = categories
            this.touched = true
            this.$emit('touched')
        },

        closeTemplateConfirm() {
            if (!this.touched) {
                this.closeTemplate()
            } else {
                this.$confirm.require({
                    message: this.$t('common.toast.unsavedChangesMessage'),
                    header: this.$t('common.toast.unsavedChangesHeader'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.touched = false
                        this.closeTemplate()
                    }
                })
            }
        }
    }
})
